<template>
  <!-- Design-system look: the one headline row of every page outside the event sections (cockpit,
       events overview, settings …): the page's name, the last breadcrumb, with the breadcrumb
       trail beside it. The pages' own titles are hidden while it shows (theme.css,
       [data-ds-page-header]). Sits on the line of the sidebar's logo row. -->
  <div
    v-if="title"
    ref="head"
    data-breadcrumbs-row
    class="mb-[21px] flex min-h-(--event-app-tabs-title,34px) flex-wrap items-center gap-x-5 gap-y-1 lg:-mt-1.5"
    data-test="page-header"
  >
    <!-- Below lg the title shares its line with the bell and the user menu and may wrap. -->
    <h1
      class="page-title ds-page-header-title max-lg:min-w-0 max-lg:flex-1 lg:flex-none"
      v-text="title"
    />
    <!-- A page may put a control right after the title here (the planner's help (?)). -->
    <span
      id="planner-title-help"
      class="-ml-3 flex items-center empty:hidden"
    />
    <!-- Below lg the trail takes a line of its own under the title, which leaves it no room on a
         phone. -->
    <Breadcrumbs class="max-lg:order-last max-lg:basis-full" />
    <HeaderActions />
  </div>
</template>

<script setup>
import Breadcrumbs from '@/Components/Sidebar/Breadcrumbs.vue'
import HeaderActions from '@/Components/Sidebar/HeaderActions.vue'
import { useBreadcrumbs } from '@/composables/breadcrumbs'
import { useStickyPageHead } from '@/composables/stickyPageHead'
import { computed, useTemplateRef } from 'vue'

const crumbs = useBreadcrumbs()

useStickyPageHead(useTemplateRef('head'))

const title = computed(() =>
  crumbs.value.length > 1 ? crumbs.value.at(-1).label : null,
)
</script>
